import { AssignmentReportExcelState, AssignmentReportExcelActionTypes, DOWNLOAD_ASSIGNMENT_REPORT_EXCEL_REQUEST, DOWNLOAD_ASSIGNMENT_REPORT_EXCEL_SUCCESS, DOWNLOAD_ASSIGNMENT_REPORT_EXCEL_FAILURE } from "store/reducers/types/assignmentReport/assignmentReportExcel";

const defaultState: AssignmentReportExcelState = {
  isLoading: false,
  errorMessage: ""
};

export default function assignmentReportExcel(state = defaultState, action: AssignmentReportExcelActionTypes): AssignmentReportExcelState {
  switch (action.type) {
    case DOWNLOAD_ASSIGNMENT_REPORT_EXCEL_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case DOWNLOAD_ASSIGNMENT_REPORT_EXCEL_SUCCESS:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    case DOWNLOAD_ASSIGNMENT_REPORT_EXCEL_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
};